
import React from 'react';

const EVERYDAY_SET = {
    title: 'Выгодный',
    description: 'шок цена \n за порцию 351₽',
    price: '3 510',
    recurrentPrice: '3 510',
    iconClass: 'profitable',
    isDynamicPrice: false,
    setType: 'tomorrow',
};

const PREMIUM_SET_GREEN_VERSION = {
    title: 'Green',
    description: 'легкие премиум ингредиенты',
    price: '5 550',
    recurrentPrice: '4 995',
    iconClass: 'green',
    isDynamicPrice: true,
    setType: 'green',
};

const OUR_SET = {
    title: 'Топ 5',
    description: 'средняя \n оценка 5.0',
    price: '3 969',
    recurrentPrice: '3 969',
    iconClass: 'top',
    isDynamicPrice: true,
    setType: 'our_set',
};

// ADDITIONAL (BOXES)
const HALLOWEEN_SET = {
    title: 'Хэллоуин',
    description: 'ужасно \n вкусный бокс',
    price: '4 880',
    recurrentPrice: '4 392',
    iconClass: 'halloween',
    isDynamicPrice: false,
    setType: null,
    period: [
        '2026-10-26',
    ],
};


export const sliderCardContentMapV2 = new Map([
    ['EVERYDAY_SET', EVERYDAY_SET],
    ['PREMIUM_SET_GREEN_VERSION', PREMIUM_SET_GREEN_VERSION],
    ['OUR_SET', OUR_SET],
]);

export const additionalCardsMap = new Map([
    ['HALLOWEEN_SET', HALLOWEEN_SET],
]);
